import { campaignDisplayLabel } from '@app/shared'
import { orgHref } from '../lib/public-router'
import { Notice } from '../ui'
import { kioskHref } from './kiosk'

export function CampaignNotCollecting({
  label,
  period,
  upcoming,
  orgShortId,
  openShortId,
  kiosk,
}: {
  label: string
  period: string | null
  upcoming: boolean
  orgShortId: string
  openShortId: string | null
  kiosk: boolean
}) {
  const href = openShortId
    ? orgHref(orgShortId, 'donate', openShortId)
    : orgHref(orgShortId, 'donate')
  return (
    <Notice tone="info">
      {campaignDisplayLabel(label, period)}{' '}
      {upcoming
        ? 'has not started collecting yet.'
        : 'has finished collecting.'}{' '}
      <a href={kioskHref(href, kiosk)}>
        {openShortId ? 'Give to the current appeal' : 'Make a general donation'}
      </a>
    </Notice>
  )
}
